export const personalAndCabinBaggageDefaultShowType = 'SEPARATE';
export const personalAndCabinBaggageShowTypePair = 'PAIR';
export const INCLUDED = 'INCLUDED';
export const SELLABLE = 'SELLABLE';
export const GFSPartner = 'gfs';
